export default [{
        path: '/management',
        name: 'management',
        component: () =>
            import ('@/views/management/Management.vue'),
        meta: {
            pageTitle: 'Management',
            breadcrumb: [{
                text: 'Management',
                active: true,
            }, ],
        },
    },
    {
        path: '/categories',
        name: 'categories',
        component: () =>
            import ('@/views/management/categories/Categories.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{
                text: 'Categories',
                active: true,
            }, ],
        },
    },
    {
        path: '/categories/create',
        name: 'categories-create',
        component: () =>
            import ('@/views/management/categories/CategoryCreate.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{

                text: 'Categories',
            }, {
                text: 'Create',
                active: true,
            }, ],
        },
    },
    {
        path: '/categories/edit/:slugParam',
        name: 'categories-edit',
        component: () =>
            import ('@/views/management/categories/CategoryEdit.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{

                text: 'Categories',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/categories/create/translation/:idParam',
        name: 'categories-create-translation',
        component: () =>
            import ('@/views/management/categories/CategoryCreateTranslation.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{

                text: 'Categories',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/categories',
        name: 'contents-categories',
        component: () =>
            import ('@/views/management/contents/ContentsCategories.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{
                text: 'Contents',
            }, {
                text: 'Categories',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/categories/:slugParam',
        name: 'contents-categories-list',
        component: () =>
            import ('@/views/management/contents/Contents.vue'),
        meta: {
            pageTitle: 'ContentsList',
            breadcrumb: [{
                text: 'Contents',
            }, {
                text: 'Categories',
            }, {
                text: 'List',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/create/:slugParam',
        name: 'contents-create',
        component: () =>
            import ('@/views/management/contents/ContentCreate.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{

                text: 'Contents',
            }, {
                text: 'Create',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/edit/:slugParam',
        name: 'contents-edit',
        component: () =>
            import ('@/views/management/contents/ContentEdit.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{

                text: 'Contents',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/create/translation/:slugParam',
        name: 'contents-create-translation',
        component: () =>
            import ('@/views/management/contents/ContentCreateTranslation.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{

                text: 'Contents',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/educators',
        name: 'educators',
        component: () =>
            import ('@/views/management/educators/Educators.vue'),
        meta: {
            pageTitle: 'Educators',
            breadcrumb: [{
                text: 'Educators',
                active: true,
            }, ],
        },
    },
    {
        path: '/educators/create',
        name: 'educators-create',
        component: () =>
            import ('@/views/management/educators/EducatorCreate.vue'),
        meta: {
            pageTitle: 'Educators',
            breadcrumb: [{

                text: 'Educators',
            }, {
                text: 'Create',
                active: true,
            }, ],
        },
    },
    {
        path: '/educators/edit/:slugParam',
        name: 'educators-edit',
        component: () =>
            import ('@/views/management/educators/EducatorEdit.vue'),
        meta: {
            pageTitle: 'Educators',
            breadcrumb: [{

                text: 'Educators',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/educators/create/translation/:slugParam',
        name: 'educators-create-translation',
        component: () =>
            import ('@/views/management/educators/EducatorCreateTranslation.vue'),
        meta: {
            pageTitle: 'Educators',
            breadcrumb: [{

                text: 'Educators',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/home',
        name: 'sliders-home',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliders.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                text: 'Home Slider',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/home/create',
        name: 'sliders-home-create',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliderCreate.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                    text: 'Home Slider',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sliders/home/edit/:idParam',
        name: 'sliders-home-edit',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliderEdit.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                text: 'Home Slider',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/home/create/translation/:idParam',
        name: 'sliders-home-create-translation',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliderCreateTranslation.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                text: 'Events',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/highlights',
        name: 'sliders-highlights',
        component: () =>
            import ('@/views/management/sliders/highlights/HighlightsSlider.vue'),
        meta: {
            pageTitle: 'Highlights',
            breadcrumb: [{
                text: 'Highlights',
            }, ],
        },
    },
    {
        path: '/sliders/programs',
        name: 'sliders-programs',
        component: () =>
            import ('@/views/management/sliders/programs/ProgramsSlider.vue'),
        meta: {
            pageTitle: 'Programs',
            breadcrumb: [{
                text: 'Programs',
            }, ],
        },
    },
    {
        path: '/sliders/interesteds',
        name: 'sliders-interesteds',
        component: () =>
            import ('@/views/management/sliders/interesteds/InterestedsSlider.vue'),
        meta: {
            pageTitle: 'Interesteds',
            breadcrumb: [{
                text: 'Interesteds',
            }, ],
        },
    },
    {
        path: '/sliders/podcasts',
        name: 'sliders-podcasts',
        component: () =>
            import ('@/views/management/sliders/podcasts/PodcastsSlider.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{
                text: 'Podcasts',
            }, ],
        },
    },
    {
        path: '/events',
        name: 'events',
        component: () =>
            import ('@/views/management/events/Events.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                text: 'Events',
                active: true,
            }, ],
        },
    },
    {
        path: '/events/create',
        name: 'events-create',
        component: () =>
            import ('@/views/management/events/EventCreate.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                    text: 'Events',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/events/edit/:slugParam',
        name: 'events-edit',
        component: () =>
            import ('@/views/management/events/EventEdit.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                text: 'Events',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/events/create/translation/:slugParam',
        name: 'events-create-translation',
        component: () =>
            import ('@/views/management/events/EventCreateTranslation.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                text: 'Events',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/podcasts',
        name: 'podcasts',
        component: () =>
            import ('@/views/management/podcasts/Podcasts.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                text: 'Podcasts',
                active: true,
            }, ],
        },
    },
    {
        path: '/podcasts/create',
        name: 'podcasts-create',
        component: () =>
            import ('@/views/management/podcasts/PodcastCreate.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                    text: 'Podcasts',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/podcasts/edit/:slugParam',
        name: 'podcasts-edit',
        component: () =>
            import ('@/views/management/podcasts/PodcastEdit.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                text: 'Podcasts',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/podcasts/create/translation/:slugParam',
        name: 'podcasts-create-translation',
        component: () =>
            import ('@/views/management/podcasts/PodcastCreateTranslation.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                text: 'Podcasts',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    }, {
        path: '/galleries',
        name: 'galleries',
        component: () =>
            import ('@/views/management/galleries/Galleries.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                text: 'Galleries',
                active: true,
            }, ],
        },
    },
    {
        path: '/galleries/create',
        name: 'galleries-create',
        component: () =>
            import ('@/views/management/galleries/GalleryCreate.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                    text: 'Galleries',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/galleries/edit/:slugParam',
        name: 'galleries-edit',
        component: () =>
            import ('@/views/management/galleries/GalleryEdit.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                text: 'Galleries',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/galleries/create/translation/:slugParam',
        name: 'galleries-create-translation',
        component: () =>
            import ('@/views/management/galleries/GalleryCreateTranslation.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                text: 'Galleries',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/books',
        name: 'books',
        component: () =>
            import ('@/views/management/books/Books.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                text: 'Books',
                active: true,
            }, ],
        },
    },
    {
        path: '/books/create',
        name: 'books-create',
        component: () =>
            import ('@/views/management/books/BookCreate.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                    text: 'Books',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/books/edit/:idParam',
        name: 'books-edit',
        component: () =>
            import ('@/views/management/books/BookEdit.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                text: 'Books',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/books/create/translation/:idParam',
        name: 'books-create-translation',
        component: () =>
            import ('@/views/management/books/BookCreateTranslation.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                text: 'Books',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/gsys',
        name: 'forms-gsys',
        component: () =>
            import ('@/views/management/forms/Gsys.vue'),
        meta: {
            pageTitle: 'Gsys',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Gsys',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/events',
        name: 'forms-events',
        component: () =>
            import ('@/views/management/forms/Events.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Events',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/contacts',
        name: 'forms-contacts',
        component: () =>
            import ('@/views/management/forms/Contacts.vue'),
        meta: {
            pageTitle: 'Contacts',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Contacts',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/participants',
        name: 'forms-participants',
        component: () =>
            import ('@/views/management/forms/Participants.vue'),
        meta: {
            pageTitle: 'Participants',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Participants',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/newsletters',
        name: 'forms-newsletters',
        component: () =>
            import ('@/views/management/forms/Newsletters.vue'),
        meta: {
            pageTitle: 'Newsletters',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Newsletters',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/explicit-consents',
        name: 'forms-explicit-consents',
        component: () =>
            import ('@/views/management/forms/ExplicitConsents.vue'),
        meta: {
            pageTitle: 'Explicit Consents',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Explicit Consents',
                active: true,
            }, ],
        },
    },


]